module.exports = __webpack_public_path__ + "2acb60f2/img/arrow-export-icon.a3345173.svg";